export class Habilidade {
  constructor({
    id = null,
    nome = null,
    codigo = null,
    descricao = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.codigo = codigo;
    this.descricao = descricao;
  }
  static Build() {
    return new Habilidade({
      id: null,
      nome: null,
      codigo: null,
      descricao: null,
    });
  }
  format() {
    return this;
  }
}
